export const environment = {
  Auth: {
    identityPoolId: 'ap-northeast-1:ddecc0df-6651-478a-8d04-e1cf1efd296d', //REQUIRED - Amazon Cognito Identity Pool ID
    region: 'ap-northeast-1', // REQUIRED - Amazon Cognito Region
    userPoolId: 'ap-northeast-1_QLCBri1Ft', //OPTIONAL - Amazon Cognito User Pool ID
    userPoolWebClientId: '1bgpmq4m764bcc7f6c2uo72ctm', //OPTIONAL - Amazon Cognito Web Client ID
  },
  API: {
    endpoints: [
      {
        name: "ishiiReportArchistr_api",
        region: "ap-northeast-1",
        endpoint: "https://v1iesnd591.execute-api.ap-northeast-1.amazonaws.com/local"
      },
      {
        name: "notification",
        endpoint: "https://s3-ap-northeast-1.amazonaws.com/nishio2test.local.dashboard.notifications",
      },
    ]
  }
}